import qs from 'querystring';
import getResponseJson from './getresponsejson';

export const LINE_OF_BUSINESS = {
  RAM: 'RAM',
  CAC: 'CAC',
  CR: 'CR',
  ACA: 'ACA',
  AUDIT: 'AUDIT',
  DRG_VALIDATOR: 'DRG VALIDATOR'
};

export const auditSearchService = serviceRoutes => {
  const init = () => {
    return fetch(serviceRoutes.init, {
      credentials: 'include',
      method: 'GET'
    })
    .then(getResponseJson)
    .then(responseJson => {
      const { result } = responseJson;
      return Promise.resolve(result);
    });
  };

  const getCodersForContract = id => {
    const params = { id };
    const queryString = qs.stringify(params);
    const url = `${serviceRoutes.getCodersForContract}?${queryString}`;

    return fetch(url, {
      credentials: 'include',
      method: 'GET'
    })
    .then(getResponseJson)
    .then(responseJson => {
      const { result } = responseJson;
      return Promise.resolve(result);
    });
  };

  const getEncounterCount = dto => {
    return fetch(serviceRoutes.getEncounterCount, {
      credentials: 'include',
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...dto
      })
    })
    .then(getResponseJson)
    .then(responseJson => {
      const { result } = responseJson;
      return Promise.resolve(result);
    });
  };

  const beginWork = () => {
    return fetch(serviceRoutes.beginWork, {
      credentials: 'include',
      method: 'GET'
    })
    .then(getResponseJson)
    .then(responseJson => {
      const { result } = responseJson;
      return Promise.resolve(result);
    });
  };

  return {
    init,
    getCodersForContract,
    getEncounterCount,
    beginWork,
    serviceRoutes
  };
};

export default auditSearchService;
